import Navigation from './_navigation.js';
import Footer from './_footer.js';
import { factory as share } from './_share.js';
import throttle from './base/_throttle.js';
import focusWithin from './base/_focus-within.js';
import keyboardFocus from './base/_keyboardFocus.js';
import smoothScroll from './base/_smoothScroll.js';
import size from './base/_size';
import tabs from './base/_tabs';
import youtube from './_youtube';

import postCard from './_postcard';
import accordion from './_accordion';
import fitlersDropdown from './_filters';
import general from './_general';
import testPlans from './_test-plans';

class CTIA {
	constructor() {
		document.addEventListener('DOMContentLoaded', this.ready.bind(this));
		window.addEventListener('load', this.load.bind(this));
		window.addEventListener('resize', throttle(this.resize.bind(this), 25));
		this.resize();
	}

	ready() {
		this.navigation = new Navigation();
		this.footer = new Footer();
		this.shares = share();

		focusWithin('label, form, fieldset');

		keyboardFocus.init();
		smoothScroll.init();
		postCard.init();
		youtube.init();
		tabs.init();
		accordion.init();
		fitlersDropdown.init();
		size.init();
		general.init();
		testPlans.init();
		window.ctia_sliders = [];
	}

	load() {

	}

	resize() {
		// using this to allow css to know if it should exclude the scroll bar in calc's
		if (window.innerWidth === document.body.clientWidth) {
			document.documentElement.classList.remove('has-scrollbar');
		} else {
			document.documentElement.classList.add('has-scrollbar');
		}
	}

}

export default new CTIA;
